module.exports = __webpack_public_path__ + "static/img/banner.616983b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/banner.jpg
// module id = 8azY
// module chunks = 0